'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var StyledTypography = styled__default(function (_ref) {
  var component = _ref.component,
      variant = _ref.variant,
      align = _ref.align,
      color = _ref.color,
      display = _ref.display,
      noWrap = _ref.noWrap,
      helpTextFontSize = _ref.helpTextFontSize,
      otherProps = _objectWithoutProperties(_ref, ["component", "variant", "align", "color", "display", "noWrap", "helpTextFontSize"]);

  var Tag = component; // eslint-disable-next-line react/jsx-props-no-spreading

  return /*#__PURE__*/React.createElement(Tag, otherProps);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: SourceSansPro, Arial, sans-serif;\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  ", ";\n  ", ";\n  // H1\n  ", ";\n  // H2\n  ", ";\n  // H3\n  ", ";\n  // H4\n  ", ";\n  // H5\n  ", ";\n  // H6\n  ", ";\n  // SUBTITLE1\n  ", ";\n  // SUBTITLE2\n  ", ";\n  // BODY1\n  ", ";\n  // BODY2\n  ", ";\n  // CAPTION\n  ", ";\n  // HELPTEXT\n  ", ";\n  // OVERLINE\n  ", ";\n  // SRONLY\n  ", ";\n"])), function (_ref2) {
  var align = _ref2.align;
  return align;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeight.normal;
}, function (_ref5) {
  var display = _ref5.display;
  return display && styled.css(["display:", ";"], display);
}, function (_ref6) {
  var noWrap = _ref6.noWrap;
  return noWrap && styled.css(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
}, function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return variant === 'h1' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tight, theme.fontSize['4xl'], "".concat(theme.breakpoints.sm), theme.fontSize['5xl'], "".concat(theme.breakpoints.md), theme.fontSize['6xl']);
}, function (_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant;
  return variant === 'h2' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tighter, theme.fontSize['2xl'], "".concat(theme.breakpoints.sm), theme.fontSize['3xl'], "".concat(theme.breakpoints.md), theme.fontSize['5xl']);
}, function (_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant;
  return variant === 'h3' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tight, theme.fontSize.lg, "".concat(theme.breakpoints.sm), theme.fontSize.xl, "".concat(theme.breakpoints.md), theme.fontSize['3xl']);
}, function (_ref10) {
  var theme = _ref10.theme,
      variant = _ref10.variant;
  return variant === 'h4' && styled.css(["line-height:", ";font-size:", ";@media only screen and (min-width:", "){font-size:", ";}"], theme.lineHeight.tighter, theme.fontSize.lg, "".concat(theme.breakpoints.md), theme.fontSize.xl);
}, function (_ref11) {
  var theme = _ref11.theme,
      variant = _ref11.variant;
  return variant === 'h5' && styled.css(["line-height:", ";font-weight:", ";font-size:", ";@media only screen and (min-width:", "){line-height:", ";font-size:", ";}"], theme.lineHeight.snug, theme.fontWeight.semibold, theme.fontSize.base, "".concat(theme.breakpoints.md), theme.lineHeight.tighter, theme.fontSize.lg);
}, function (_ref12) {
  var theme = _ref12.theme,
      variant = _ref12.variant;
  return variant === 'h6' && styled.css(["line-height:", ";font-weight:", ";font-size:", ";@media only screen and (min-width:", "){line-height:", ";font-size:", ";}"], theme.lineHeight.normal, theme.fontWeight.semibold, theme.fontSize.sm, "".concat(theme.breakpoints.md), theme.lineHeight.tight, theme.fontSize.base);
}, function (_ref13) {
  var theme = _ref13.theme,
      variant = _ref13.variant;
  return variant === 'subtitle1' && styled.css(["font-weight:", ";line-height:", ";font-size:", ";"], theme.fontWeight.normal, theme.lineHeight.snug, theme.fontSize.lg);
}, function (_ref14) {
  var theme = _ref14.theme,
      variant = _ref14.variant;
  return variant === 'subtitle2' && styled.css(["font-weight:", ";line-height:", ";font-size:", ";"], theme.fontWeight.bold, theme.lineHeight.snug, theme.fontSize.base);
}, function (_ref15) {
  var theme = _ref15.theme,
      variant = _ref15.variant;
  return variant === 'body1' && styled.css(["line-height:", ";font-size:", ";"], theme.lineHeight.snug, theme.fontSize.base);
}, function (_ref16) {
  var theme = _ref16.theme,
      variant = _ref16.variant;
  return variant === 'body2' && styled.css(["line-height:", ";font-size:", ";"], theme.lineHeight.snug, theme.fontSize.sm);
}, function (_ref17) {
  var theme = _ref17.theme,
      variant = _ref17.variant;
  return variant === 'caption' && styled.css(["line-height:", ";font-size:", ";letter-spacing:0.15rem;font-weight:", ";text-transform:uppercase;color:", ";"], theme.lineHeight.tight, theme.fontSize['2xs'], theme.fontWeight.normal, theme.colors.grey600);
}, function (_ref18) {
  var theme = _ref18.theme,
      variant = _ref18.variant;
  return variant === 'helpText' && styled.css(["font-weight:", ";color:", ";", ";"], theme.fontWeight.normal, theme.colors.grey600, function (_ref19) {
    var helpTextFontSize = _ref19.helpTextFontSize;
    return helpTextFontSize && styled.css(["font-size:", ";"], theme.fontSize["".concat(helpTextFontSize)]);
  });
}, function (_ref20) {
  var theme = _ref20.theme,
      variant = _ref20.variant;
  return variant === 'overline' && styled.css(["line-height:", ";font-size:", ";letter-spacing:0.02rem;font-weight:", ";text-transform:uppercase;color:", ";"], theme.lineHeight.tight, theme.fontSize['2xs'], theme.fontWeight.semibold, theme.colors.placeholderText);
}, function (_ref21) {
  var variant = _ref21.variant;
  return variant === 'srOnly' && styled.css(["width:1px;height:1px;overflow:hidden;position:absolute;"]);
});

var variantTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'p',
  subtitle2: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'caption',
  helpText: 'helpText',
  overline: 'span',
  srOnly: 'span'
};

var Typography = function Typography(_ref) {
  var variant = _ref.variant,
      component = _ref.component,
      children = _ref.children,
      align = _ref.align,
      color = _ref.color,
      display = _ref.display,
      noWrap = _ref.noWrap,
      style = _ref.style,
      className = _ref.className,
      helpTextFontSize = _ref.helpTextFontSize,
      props = _objectWithoutProperties(_ref, ["variant", "component", "children", "align", "color", "display", "noWrap", "style", "className", "helpTextFontSize"]);

  var componentToRender = component || variantTags[variant];
  return /*#__PURE__*/React.createElement(StyledTypography, _extends({
    component: componentToRender,
    variant: variant,
    align: align,
    color: color,
    display: display,
    noWrap: noWrap,
    style: style,
    className: className,
    helpTextFontSize: helpTextFontSize // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), children);
};

Typography.propTypes = {
  /**
   * The typography style to render
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'helpText', 'overline', 'srOnly']),

  /**
   * The component used for the root node (e.g. p, div, span...)
   */
  component: PropTypes.string,

  /**
   * Set the text-align on the component
   */
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),

  /**
   * The color of the component
   */
  color: PropTypes.string,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If true the text will not wrap, but instead will truncate with a text
   * overflow ellipsis. Note that text overflow can only happen with block
   * or inline-block level elements (the element needs to have a width in order
   * to overflow)
   */
  noWrap: PropTypes.bool,

  /**
   * Additional styles - if using this a div will be rendered within the typography element,
   *  which may cause errors (e.g. you cannot have a div within a p tag). If so, use the `component` prop
   *  to change the HTML element being rendered (e.g. `component="div"`).
   */
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),

  /**
   * Classes to be applied to the rendered element
   */
  className: PropTypes.string,

  /**
   * Set this value to override helpText default font size (2xs). Note that
   * it will only take effect when variant set to 'helpText'.
   *
   * The array list must match the keys in theme.fontSize
   */
  helpTextFontSize: PropTypes.oneOf(['', '2xs', 'xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl'])
};
Typography.defaultProps = {
  variant: 'body1',
  component: null,
  align: 'left',
  color: 'inherit',
  display: null,
  noWrap: false,
  children: [],
  style: null,
  className: '',
  helpTextFontSize: ''
};

exports.Typography = Typography;
